import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import moment from 'moment';
import { hourMin } from 'Consts/DateFormats';
import PropTypes from 'prop-types';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Fade from '@mui/material/Fade';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('MessageTime', (() => ({
  root: {},
})));

const MessageTime = ({ messageResource }) => {
  const classes = useStyles();
  const isDraft = messageResource.isTruthy('isDraft');
  const messageMoment = (isDraft) ? moment() : moment(messageResource.attr('publishedDate'));

  return (
    <Tooltip
      placement={'top'}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 0 }}
      title={
        <Text
          color={'white'}
          weight={'book'}
          text={`Sent ${messageMoment.format('llll')}`}
        />
      }
      arrow
    >
      <Typography
        className={classes.root}
        variant={'body1'}
        color={'primaryGray'}
        weight={'book'}
        align={'left'}
        {...DataValueMap.init('message-sent-time')
          .append(DataValueMap.keyMap.dataResourceId, messageResource.id())
          .build()}
      >
        {messageMoment.format(hourMin)}
      </Typography>
    </Tooltip>
  );
};

MessageTime.propTypes = {
  messageResource: PropTypes.object.isRequired,
};

export default MessageTime;
